<template>
  <div
    class="flex-1 flex flex-col justify-start items-center bg-pitch-black text-prime-golden"
  >
    <!-- Call Content based on state -->
    <div class="flex flex-col justify-center flex-1 items-center">
      <div
        class="w-20 h-20 mb-4 rounded-full flex items-center justify-center bg-light-grey-translucent-dark border border-light-grey-translucent-dark overflow-hidden"
      >
        <template v-if="callerAvatar">
          <img
            :src="callerAvatar"
            alt="Profile Image"
            class="w-full h-full rounded-full"
          />
        </template>
        <template v-else>
          <i class="fa-solid fa-user text-6xl text-pitch-black -mb-[1px] mt-auto"></i>
        </template>
      </div>
      <h2 class="text-2xl text-total-white">{{ callerName }}</h2>

      <!-- Active Call State -->
      <div v-if="callState === 'active'" class="text-total-white mb-12">
        <p v-if="callDuration === 0" class="text-xl font-medium mb-12 mt-2">Connecting ...</p>
        <p v-if="callDuration !== 0" class="text-xl font-semibold mb-10 mt-2">{{ `${String(Math.floor(callDuration / 60)).padStart(2, '0')}:${String(callDuration % 60).padStart(2, '0')}` }}</p>

        <!-- Call control buttons (mute, keypad, speaker) -->
        <div class="flex w-full justify-center gap-6 my-6">
          <button
            @click="muteCall"
            :class="{'opacity-50': !isMuted}"
            class="w-20 h-20 rounded-full bg-prime-golden-100 flex justify-center items-center text-prime-golden text-2xl"
          >
            <i class="fas fa-microphone-slash"></i>
          </button>
          <!--<button
            class="w-20 h-20 rounded-full bg-prime-golden-100 flex justify-center items-center text-prime-golden text-2xl"
          >
            <img class="-mb-1" src="../assets/images/keypad.svg" />
          </button>-->
          <!--<button
            @click="toggleSpeaker"
            :class="{'opacity-50': !isSpeakerOn}"
            class="w-20 h-20 rounded-full bg-prime-golden-100 flex justify-center items-center text-prime-golden text-2xl"
          >
            <i class="fas fa-volume-up"></i>
          </button>-->
        </div>
      </div>

      <!-- Incoming Call State -->
      <div v-else-if="callState === 'incoming'" class="text-total-white mb-4">
        <p class="text-2xl font-semibold mb-24">Incoming Call</p>

        <!-- Accept/Decline buttons for incoming call -->
        <div class="grid grid-cols-2 gap-10">
          <div>
            <button
              @click="acceptCall"
              class="bg-olive-green border mb-2 text-pitch-black border-forest-olive w-20 h-20 rounded-full flex items-center justify-center"
            >
              <i class="fas text-2xl fa-phone"></i>
            </button>
            <span>accept</span>
          </div>
          <div>
            <button
              @click="declineCall"
              class="bg-deep-rust mb-2 border-blush-red border w-20 h-20 text-pitch-black rounded-full flex items-center justify-center"
            >
              <i class="fas text-2xl fa-phone rotate-[135deg]"></i>
            </button>
            <span>decline</span>
          </div>
        </div>
      </div>

      <!-- Common End Call Button -->
      <div v-if="callState === 'active'" class="flex justify-center">
        <button
          @click="endCall"
          class="bg-deep-rust border-blush-red border w-20 h-20 text-pitch-black rounded-full flex items-center justify-center"
        >
          <i class="fas text-2xl fa-phone rotate-[135deg]"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  props: {
    selectedProject: {
      type: String,
      default: "Cindy's House",
    },
    callerName: {
      type: String,
      default: "Unknown",
    },
    callerAvatar: {
      type: String,
      default: "", // Add a default avatar if needed
    },
    callState: {
      type: String, // 'incoming' or 'active'
      default: "incoming",
    },
    callDuration: {
      type: String,
      default: "0:00", // You can update this dynamically when the call is active
    },
  },
  data() {
    const isMuted = ref(false);
    const isSpeakerOn = ref(false);

    return {
      isMuted, // Track mute state
      isSpeakerOn, // Track speaker state
    };
  },
  methods: {
    toggleContactSearch() {
      console.log("Searching contacts...");
    },
    acceptCall() {
      console.log("Call accepted");
      this.$emit("callStateChange", "active");
    },
    declineCall() {
      console.log("Call declined");
      // Handle declining the call (redirect, etc.)
    },
    endCall() {
      console.log("Ending call...");
      this.$emit("callStateChange", "endCall");
    },
    muteCall() {
      this.isMuted = !this.isMuted; // Toggle mute state
      console.log(this.isMuted ? "Call muted" : "Call unmuted");
      this.$emit("muteToggle", this.isMuted); // Emit event for mute
    },
    toggleSpeaker() {
      this.isSpeakerOn = !this.isSpeakerOn; // Toggle speaker state
      console.log(this.isSpeakerOn ? "Speaker mode on" : "Speaker mode off");
      this.$emit("speakerToggle", this.isSpeakerOn); // Emit event for speaker mode
    },
  },
};
</script>
